import { cloneElement, isValidElement } from 'react';
import { StackedIcon } from '@eti/components';
import { cx } from '@eti/styles';
import getProductIcon from '../resolvers/productIconResolver';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductIcon = ({
  className,
  id,
  type
}) => {
  const icon = getProductIcon(id, type);
  return /*#__PURE__*/isValidElement(icon) ? (/*#__PURE__*/cloneElement(icon, {
    className: cx('etiProductIcon', className)
  })) : /*#__PURE__*/_jsx(StackedIcon, {
    className: cx('etiProductIcon', className),
    "data-testid": `${id}-ProductIcon`,
    icons: icon
  });
};
export default ProductIcon;
//# sourceMappingURL=ProductIcon.js.map